import axios from '../utils/axios'

// 微信提现
export function WeChatTransfer () {
  return axios({
    url: '/Member/TransferAccounts/WeChatTransfer',
    method: 'post'
  })
}


// 支付宝提现
export function AlipayTransfer () {
  return axios({
    url: '/Member/AlipayTransferAccounts/WeChatTransfer',
    method: 'post'
  })
}

// 银行卡提现
export function BankCardTransfer () {
  return axios({
    url: '/Member/TransferAccounts/BankCardTransfer',
    method: 'post'
  })
}

// 待扣金额支付
export function SAppAddDeductAmount (params) {
  return axios({
    url: '/Member/SAppWxPay/SAppAddDeductAmount',
    method: 'post',
    params: params
  })
}

// 查询支付状态接口
export function QueryWxPayTransactionStatus (params) {
  return axios({
    url: '/Member/SAppWxPay/QueryWxPayTransactionStatus',
    method: 'post',
    params: params
  })
}

// 获取待扣金额明细数据接口
export function WaitDeductAmountItemGet (params) {
  return axios({
    url: '/Member/SApp/WaitDeductAmountItemGet',
    method: 'post',
    params: params
  })
}